import API from '../../../helpers/api';

import { message } from '../../../utils/message';

import SUPPORT from '../actionTypes';

import { AppDispatch, GetState } from '../../../types/app';

export const send =
  (formValues: Record<string, unknown>) =>
  async (dispatch: AppDispatch, getState: GetState): Promise<boolean> => {
    dispatch({ type: SUPPORT.SUPPORT.REQUESTING });

    const { intl, Data } = getState();
    const lang = intl.locale;
    const limitMin = Data.config?.support?.limitMin || 10;

    try {
      const { Attach, ...values } = formValues;

      const variables = {
        ...values,
        Lang: lang,
        Attach:
          Attach && typeof Attach !== 'string' ? (Attach as File) : undefined,
      };

      await API.callGraphQL(
        `
      mutation ($Subject: String!, $Body: String!, $Lang: String!, $Attach: Upload) {
        result: profileSupport(Subject: $Subject, Body: $Body, Lang: $Lang, Attach: $Attach)
      }
    `,
        variables,
        variables.Attach ? { Attach: variables.Attach } : null
      );

      dispatch({ type: SUPPORT.SUPPORT.SUCCESS });

      message.success('support.success');
      return true;
    } catch (err) {
      dispatch({ type: SUPPORT.SUPPORT.FAILURE, err: err.message });
      if (err.message === 'SupportLimit') {
        message.error({
          message: 'SupportLimit',
          extensions: { value: limitMin },
        } as Parameters<typeof message.error>[0]);
      } else {
        message.error(err);
      }
      return false;
    }
  };
